import { DBSchema, IDBPDatabase, openDB } from 'idb';

export type CacheKind = 'list' | 'entity' | 'selectors' | 'prefetch';
export type WriteMethod = 'POST' | 'PUT' | 'DELETE';
export type WriteStatus = 'pending' | 'syncing' | 'synced' | 'failed';

export interface ReadCacheEntry {
    key: string;
    url: string;
    method: 'GET';
    response: any;
    cachedAt: number;
    kind: CacheKind;
}

export interface WriteQueueEntry {
    id?: number;
    method: WriteMethod;
    url: string;
    body: any;
    entityType: string;
    tempId: number | null;
    status: WriteStatus;
    attempts: number;
    lastError: string | null;
    createdAt: number;
    updatedAt: number;
}

export interface IdMapEntry {
    tempId: number;
    realId: number;
    entityType: string;
    resolvedAt: number;
}

interface OfflineDBSchema extends DBSchema {
    read_cache: {
        key: string;
        value: ReadCacheEntry;
        indexes: { 'by-url': string };
    };
    write_queue: {
        key: number;
        value: WriteQueueEntry;
        indexes: { 'by-status': string; 'by-entity-temp': [string, number] };
    };
    id_map: {
        key: number;
        value: IdMapEntry;
    };
}

const DB_NAME = 'erp_offline_db';
const DB_VERSION = 1;

let dbPromise: Promise<IDBPDatabase<OfflineDBSchema>> | null = null;

export function openOfflineDb(): Promise<IDBPDatabase<OfflineDBSchema>> {
    if (!dbPromise) {
        dbPromise = openDB<OfflineDBSchema>(DB_NAME, DB_VERSION, {
            upgrade(db) {
                if (!db.objectStoreNames.contains('read_cache')) {
                    const store = db.createObjectStore('read_cache', { keyPath: 'key' });
                    store.createIndex('by-url', 'url');
                }
                if (!db.objectStoreNames.contains('write_queue')) {
                    const store = db.createObjectStore('write_queue', { keyPath: 'id', autoIncrement: true });
                    store.createIndex('by-status', 'status');
                    store.createIndex('by-entity-temp', ['entityType', 'tempId']);
                }
                if (!db.objectStoreNames.contains('id_map')) {
                    db.createObjectStore('id_map', { keyPath: 'tempId' });
                }
            },
        });
    }
    return dbPromise;
}
